import React, { useState } from "react";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { GiTeacher } from "react-icons/gi";
import { MdLocalLibrary as LocalLibraryIcon } from "react-icons/md";
import { Divider, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { MyBox, styles } from "./styles";
import DialogBox from "../../Common/DialogBox/dialogBox";
import { useTheme } from '@mui/material/styles';
import { initializeSteps } from "../../../Infrastructure/States/educatorStepsSlice";
import { useDispatch } from "react-redux";
import { auth } from "../../../Infrastructure/config";
import paths from "../../../Infrastructure/Router/paths";

const WelcomeBox = ({ userData }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const uid = auth?.currentUser?.uid;
  const is_educator = userData?.is_educator
  const [open, setOpen] = React.useState(false);
  const message = "Educator Onboarding Complete";
  const [isClicked, setIsClicked] = useState(true);
  const onboardingComplete = userData?.educator?.onboarding_complete;
  const handleButtonClick = (val) => {
    if (val.value === 1) {
      setIsClicked(true);
    } else {
      setIsClicked(false);
    }
  };
  const navigateToBecomeEdu = async () => {
    if (!uid) {
      navigate(paths.onboardingPage.path, { state: { from: location.pathname } });
    }
    if (is_educator) {
      if (onboardingComplete) {
        setOpen(true);
      } else {
        dispatch(initializeSteps(userData?.educator?.onboarding_step))
        navigate(paths.onboardingPage.path, { state: { from: location.pathname } });
      }
    } else {
      setOpen(true);
    }
  };
  const navigateToCourses = () => {
    navigate(paths.coursesPage.path);
  };
  return (
    <>
      <DialogBox open={open} setOpen={setOpen} message={is_educator ? message : "Must have Educator Account"} />
      <Grid container item sx={styles.mainGrid}>
        <MyBox sx={styles.item}>
          <Grid
            display="flex"
            justifyContent="space-around"
            alignItems="center"
          >
            <Grid
              onClick={(e) => handleButtonClick({ value: 1 })}
              sx={styles.subGrid}
            >
              {isClicked ? (
                <GiTeacher size={'50px'} color={theme.palette.primary.main} />
              ) : (
                <GiTeacher size={'50px'} />
              )}
              <Box>
                <Typography variant="body5">Teach</Typography>
                {isClicked ? (
                  <Divider sx={{...styles.dividerAfterClick, borderColor: `${theme.palette.primary.main} !important`}} />
                ) : (
                  <Divider sx={styles.dividerbeforeClick} />
                )}
              </Box>
            </Grid>
            <Divider sx={styles.dividerStyle} />
            <Grid
              onClick={(e) => handleButtonClick({ value: 2 })}
              sx={styles.subGrid}
            >
              {isClicked ? (
                <LocalLibraryIcon size={'50px'} />
              ) : (
                <LocalLibraryIcon size={'50px'} color={theme.palette.primary.main} />
              )}
              <Box>
                <Typography variant="body5">Learn</Typography>
                {isClicked ? (
                  <Divider sx={styles.dividerbeforeClick} />
                ) : (
                  <Divider sx={{...styles.dividerAfterClick,  borderColor: `${theme.palette.primary.main} !important`}} />
                )}
              </Box>
            </Grid>
          </Grid>
          {isClicked ? (
            <>
              <Typography variant="body2">
                Become an Educator <br /> on the Vulcan Platform
              </Typography>
              <Typography variant="body5" sx={styles.boxDescription}>
                Earn money teaching live online classes on any subject matter of your
                expertise.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body2">
                Enroll in a Course <br /> on the Vulcan Platform
              </Typography>
              <Typography variant="body5" sx={styles.boxDescription}>
                Learn directly from subject matter experts in live classes.
                Courses available soon.
              </Typography>
            </>
          )}

          <Box display="flex" justifyContent="center" mt={6} height={40}>
            {isClicked ? (
              <Button
                onClick={navigateToBecomeEdu}
                variant="contained"
                sx={styles.textCapitalize}
              >
                Sign Up To Teach
              </Button>
            ) : (
              <Button
                onClick={navigateToCourses}
                variant="contained"
                sx={styles.textCapitalize}
              >
                See Courses
              </Button>
            )}
          </Box>
        </MyBox>
      </Grid>
    </>
  );
};

export default WelcomeBox;
